import React, { useEffect, useMemo, useState } from 'react';
import { getFeedsStats } from '@/pages/opinion/services';
import Sentiment from '@/pages/opinion/components/Snippets/Sentiment';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import SortBySelect from '@op/components/FilterBoxCommon/filters/single-select-factory';
import classnames from 'classnames';
import { reviewsFormat } from '@op/utils/value';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import './index.scss';

const typeOption = [
  { text: 'Mentions by sentiment', value: 'review' },
  { text: 'Engagement by sentiment', value: 'engagement_review' },
  { text: 'Likes by sentiment', value: 'like_review' },
];

export default function CardSentiment({
  keepParams,
  sentimentsData,
  options = typeOption,
  className,
  hideOptions = false,
  title,
}: any) {
  const [type, setType] = useState('review');

  const [sentiments, setSentiments] = useState<Record<string, any>>({});

  const { Sentiment_Rating } = useGetSingePageSourceRule({
    keys: ['Sentiment_Rating'],
  });

  useEffect(() => {
    if (sentimentsData) {
      setSentiments(sentimentsData);
      return;
    }

    if (!keepParams.edition_unified_id) return;
    setSentiments({});
    getFeedsStats(keepParams).then((data: any) => {
      setSentiments(data);
    });
  }, [keepParams, sentimentsData]);

  const formatData = (value: number | undefined) => {
    if (!value) {
      return '-';
    }
    // if (value && value < 1) {
    //   return '< 1%';
    // }
    return `${reviewsFormat(value, 0)}%`;
  };

  const sentimentTypes = useMemo(() => {
    let good = 'good_';
    let bad = 'bad_';
    if (type !== 'review') {
      good = 'positive_';
      bad = 'negative_';
    }

    return [
      { key: `${good}${type}`, sentiment: 5 },
      { key: `${bad}${type}`, sentiment: 1 },
      { key: `neutral_${type}`, sentiment: 3 },
    ];
  }, [type]);

  if (Sentiment_Rating) return null;
  return (
    <div
      className={classnames(
        'dbo-accountsbox-keywords',
        'keywordbox-sentimentbox',
        className,
      )}
    >
      {title && (
        <span
          className={classnames('dbo-accountsbox-keywords-title', className)}
        >
          {title}
        </span>
      )}
      {!hideOptions && (
        <SortBySelect
          defaultValue={type}
          onChange={(key: string, value: any) => {
            buriedBtnPoint('SentimentStatisticsTAB', value);
            setType(value);
          }}
          defaultParams={{
            options,
            matchButtonWidth: true,
          }}
        />
      )}
      <div
        className={`dbo-keywordbox-sentiment-list ${title ? 'has-title' : ''}`}
        style={{ display: 'flex' }}
      >
        {sentimentTypes.map(({ key, sentiment }) => (
          <span className="keywordbox-sentiment" key={key}>
            <Sentiment
              iconClassName="keywordbox-sentiment-icon"
              showValue={false}
              sentiment={sentiment}
            />
            <span>{formatData(sentiments?.[key])}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
